import axiosInstance from './axiosInstance';

const handleGet = (client, path, paramsOrId) => {
    if (paramsOrId === 'new') return Promise.resolve({});
    if (typeof paramsOrId === 'object') {
        return client.get(path, { params: paramsOrId }).then(res => res.data);
    } else if (paramsOrId !== undefined) {
        return client.get(`${path}/${paramsOrId}`).then(res => res.data);
    } else {
        return client.get(path).then(res => res.data);
    }
};

const handlePost = (client, path, data) => {
    return client.post(path, data).then(res => res.data);
};

const handlePostForm = (client, path, data) => {
    return client.postForm(path, data).then(res => res.data);
};

const handlePut = (client, path, id, data) => {
    return client.put(`${path}/${id}`, data).then(res => res.data);
};

const handlePatch = (client, path, id, data) => {
    return client
        .patch(`${path}${id ? `/${id}` : ''}`, data)
        .then(res => res.data);
};

const handleBatchPatch = (client, path, data) => {
    return client.patch(path, data).then(res => res.data);
};

const handlePatchForm = (client, path, id, data) => {
    return client.patchForm(`${path}/${id}`, data).then(res => res.data);
};

const handlePutForm = (client, path, id, data) => {
    return client.putForm(`${path}/${id}`, data).then(res => res.data);
};

const handleDelete = (client, path, id) => {
    return client.delete(`${path}/${id}`).then(res => res.data);
};

const handleBatchDelete = (client, path, data) => {
    return client.delete(path, { data }).then(res => res.data);
};

const handlePostAction = (client, path, action, id, data) => {
    return client.post(`${path}/${id}/${action}`, data).then(res => res.data);
};

const createApiProxy = (client, basePath = '') => {
    return new Proxy(
        {},
        {
            get(_, prop) {
                const methods = {
                    get: paramsOrId => handleGet(client, basePath, paramsOrId),
                    post: data => handlePost(client, basePath, data),
                    postForm: data => handlePostForm(client, basePath, data),
                    put: (id, data) => handlePut(client, basePath, id, data),
                    patch: (id, data) =>
                        handlePatch(client, basePath, id, data),
                    batchPatch: data =>
                        handleBatchPatch(client, basePath, data),
                    patchForm: (id, data) =>
                        handlePatchForm(client, basePath, id, data),
                    putForm: (id, data) =>
                        handlePutForm(client, basePath, id, data),
                    delete: id => handleDelete(client, basePath, id),
                    batchDelete: data =>
                        handleBatchDelete(client, basePath, data),
                    duplicate: id =>
                        handlePostAction(client, basePath, prop, id),
                    schedule: (id, data) =>
                        handlePostAction(client, basePath, prop, id, data),
                    unschedule: id =>
                        handlePostAction(client, basePath, prop, id),
                    send: id => handlePostAction(client, basePath, prop, id),
                };

                const newPath = basePath ? `${basePath}/${prop}` : prop;

                return methods[prop] || createApiProxy(client, newPath);
            },
        },
    );
};

const api = createApiProxy(axiosInstance);

export default api;
